export default function Contact() {
  return (
    <section id="contact" className="border-b border-rule">
      <div className="mx-auto max-w-[1280px] px-6 py-20 md:px-10 md:py-32">
        <div className="grid gap-12 md:grid-cols-12 md:items-end">
          <div className="md:col-span-8">
            <p className="label-mono mb-6 text-accent">— 04 / Gespräch</p>
            <h2 className="text-3xl font-bold uppercase tracking-[-0.01em] text-ink md:text-4xl">
              Lassen Sie uns über
              <br />
              Ihre Dokumente reden<span className="text-accent">.</span>
            </h2>
            <p className="mt-6 max-w-xl text-fg-muted">
              Ein 30-Minuten-Call. Wir schauen uns Ihren Anwendungsfall an, sagen ehrlich, ob wir
              helfen können, und kommen mit einem Vorschlag und einem Preis zurück. Antwort
              innerhalb von zwei Werktagen.
            </p>
          </div>
          <div className="md:col-span-4">
            <a
              href="mailto:ai@nexenio.com?subject=ai.nexenio.com%20%E2%80%94%20OCR-Anfrage"
              className="group block border border-accent bg-bg-elev px-6 py-5 hover:bg-bg-elev/60"
            >
              <span className="font-mono text-[11px] uppercase tracking-[0.14em] text-fg-muted">
                E-Mail
              </span>
              <span className="mt-2 block text-lg font-semibold text-ink group-hover:text-accent">
                ai@nexenio.com →
              </span>
            </a>
            <p className="mt-4 font-mono text-[12px] uppercase tracking-[0.14em] text-fg-muted">
              neXenio GmbH · Rummelsburger Seeblick 1 · 10317 Berlin
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
